import Column from "@components/Grid/Column";

/**
 * component to render in declaration tab at How to Nominate page
 */
const DeclarationSection = (): React.ReactElement => {
  const divClassName = "mb-6";

  return (
    <Column rootClassName="bg-gray-150 py-4 px-6 font-public-sans">
      <div className={divClassName}>
        <div>
          1. By submitting this nomination form in relation to the
          Sustainability Impact Awards (“Award”), each nominator hereby agrees
          with SPH Media and the organisers to be bound by and comply with all
          the terms and conditions in this form (“Terms & Conditions”):
        </div>
        <div>
          (a) that all figures provided in the nomination form, except for the
          gross operating profit figures, are non-confidential information and
          may be published and used for research and analytics purposes;
        </div>
        <div>
          (b) to provide relevant company information should the organisers need
          to verify the data provided in the nomination form (upon request);
        </div>
        <div>
          (c) to provide the company’s projected financial figures for the
          relevant financial periods (upon request);
        </div>
        <div>
          (d) to notify the organisers in the event your company, holding
          company or subsidiaries have successfully applied for public listing
          and expect such a listing to occur;
        </div>
        <div>
          (e) to notify the organisers in the event of any changes to your
          company&apos;ss eligibility for the Award;
        </div>
        <div>
          (f) to provide details of any litigation cases against your company
          and/or your company&apos;ss directors/shareholders in the run-up to
          the publication of the Award listing;
        </div>
        <div>
          (g) to abide by the publicity schedules and guidelines stipulated by
          the organisers in the run-up to and after the publication of the Award
          listing;
        </div>
        <div>
          (h) to provide relevant information about your company for purposes of
          inclusion in Award-related collaterals, including but not limited to
          books, write-ups, etc.;
        </div>
        <div>
          (i) to abide by the rules and standards regarding the usage of the
          Award logo as notified to you by the organisers or otherwise available
          on
        </div>
        <a
          className="break-words text-[#007bad] underline hover:text-gray-750"
          href="https://static1.businesstimes.com.sg/s3fs-public/2023-01/sustainability-impact-awards-logo_t_c.pdf"
        >
          {" "}
          https://www.businesstimes.com.sg/s3fs-public/2023-01/sustainability-impact-awards-logo_t_c.pdf
        </a>
        .
      </div>

      <div className={divClassName}>
        <div>2. Each nominator further agrees and consents to:</div>

        <div>
          (a) the terms of our SPH Media Privacy Policy which can be found at
          <a
            className="break-words text-[#007bad] underline hover:text-gray-750"
            href="https://sph.com.sg/legal/sph_privacy.html"
          >
            {" "}
            https://sph.com.sg/legal/sph_privacy.html
          </a>
          as amended from time to time, and the terms of the Privacy Policy are
          incorporated into these Terms & Conditions by reference;
        </div>

        <div>
          (b) the terms of our SPH Media Member Terms and Conditions, which can
          be found at
          <a
            className="break-words text-[#007bad] underline hover:text-gray-750"
            href="https://sph.com.sg/legal/member_conditions.html"
          >
            {" "}
            https://sph.com.sg/legal/member_conditions.html{" "}
          </a>
          as amended from time to time, and the terms of the SPH Media Member
          Terms and Conditions are incorporated into these Terms & Conditions by
          reference. In the event of conflict between these Terms & Conditions
          and the SPH Member Terms and Conditions, these Terms & Conditions
          shall prevail;
        </div>

        <div>
          (c) SPH Media and its related corporations and the partners and
          sponsors of the Award, as well as their respective representatives,
          agents or authorised service providers, collecting, using and
          disclosing any and all personal data and sharing the personal data
          between themselves and their business parties to communicate with the
          individuals for purposes related to the nomination and the Award, to
          provide goods and services to the individuals upon request, to send
          the individuals marketing information on products and services offered
          by SPH Media or other parties, and for such purposes that the
          individuals may have otherwise given his/her consent to SPH Media;
        </div>

        <div>
          (d) SPH Media, as well as their respective representatives, agents or
          authorised service providers, collecting, using, disclosing and
          processing the personal data, and sharing between themselves and their
          business partners the personal data, including the photographs or
          audio-video or other recordings of these participants (“Material”) for
          publicity and/or use in advertisements across all media, including,
          without limitation, in SPH Media’s publications, presentations,
          promotional materials on their websites and social media, in its
          original or edited format, and whether to promote the Award or
          otherwise without further notification, remuneration or compensation;
          and
        </div>

        <div>
          (e) the copyright and all other intellectual property rights in and to
          all Material shall vest solely and absolutely in SPH Media without
          further compensation, and to the maximum extent permissible under law,
          each nominator hereby waives his/her moral rights comprised in and to
          all Material in favour of SPH Media.
        </div>
      </div>

      <div className={divClassName}>
        <div>
          3. Additionally, each nominator hereby represents to SPH Media that:
        </div>

        <div>
          (a) the particulars and information furnished to SPH Media in this
          form are true and correct, and have satisfied the assessment criteria
          stipulated by the Award organisers;
        </div>

        <div>
          (b) where he/she provides SPH Media with any personal data relating to
          a third party (e.g. a nominee and nominee’s officers/employees), by
          submitting such information to us, he/she represents to SPH Media that
          he/she has obtained the consent of the third party to enable he/she to
          provide SPH Media with the third party’s personal data for the
          respective purposes.
        </div>
      </div>

      <div className={divClassName}>
        4. Nominators are required to provide their particulars for the purpose
        of verification and audit.
      </div>

      <div className={divClassName}>
        5. The decisions of the evaluation panel on the Award are final and
        conclusive, and no appeals will be entertained. SPH Media and the
        organisers reserve their rights to revoke an Award in the event of
        non-compliance with any of the above conditions.
      </div>

      <div className={divClassName}>
        6. SPH Media and SPH Media’s partners, organisers and/or sponsors for
        the Award (if applicable) shall not be liable for any loss (including,
        without limitation, indirect or consequential loss), damage, personal
        injury or death in connection with the Award or prize, except any
        liability that cannot be excluded by law (in which case that liability
        is limited to the minimum allowable by law).
      </div>

      <div className={divClassName}>
        7. For purposes of these Terms & Conditions, “SPH Media” means SPH Media
        Limited and its related corporations.
      </div>

      <div>
        8. Submission of this nomination form is deemed acceptance of these
        Terms & Condition and any amendments and modifications hereto, which
        shall be final and binding in all respects on each nominator. Amendments
        to these Terms & Conditions will be posted at
        <a
          className="break-words text-[#007bad] underline hover:text-gray-750"
          href="https://static1.businesstimes.com.sg/s3fs-public/2023-01/sustainability-impact-awards-logo_t_c.pdf"
        >
          {" "}
          https://www.businesstimes.com.sg/s3fs-public/2023-01/sustainability-impact-awards-logo_t_c.pdf{" "}
        </a>
      </div>
    </Column>
  );
};

export default DeclarationSection;
